import { CircularProgress, IconButton } from "@mui/material";
import { FiAlertTriangle } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import classes from "./styles.module.css";

export const BookingLoadingState = () => {
  const { t } = useTranslation();

  return (
    <div
      className={classes.loadingIndicator}
      role="status"
      aria-label={t("general.loading")}
    >
      <span className={classes.loadingSpinnerReveal} aria-hidden="true">
        <CircularProgress size={40} />
      </span>
    </div>
  );
};

interface BookingErrorStateProps {
  onRetry(): void;
}

export const BookingErrorState = ({ onRetry }: BookingErrorStateProps) => {
  const { t } = useTranslation();

  return (
    <div role="alert">
      <IconButton aria-label={t("general.retry")} onClick={onRetry}>
        <FiAlertTriangle aria-hidden color="red" />
      </IconButton>
    </div>
  );
};
